// Module
var code = "<div class=\"gap-floating-bubble\" @click=\"commands.markGap\" tabindex=\"-1\" :title=\"title\" :style=\"`left: ${data.menu.left}px; bottom: ${data.menu.bottom}px;`\" :class=\"{ 'is-active': menu.isActive, hidden: !showBubble }\"> <AddIcon class=\"icon\"></AddIcon> </div>";
// Exports
module.exports = code;